<h2 mat-dialog-title class="title">{{data.title}}</h2>
<mat-dialog-content>
  <div class="text" [innerHtml]="data.text | safeHtml"></div>
</mat-dialog-content>


<mat-dialog-actions>
    <button [mat-dialog-close] ="true" class="button" style="overflow: hidden;">{{'label.Agree' | translate}}</button>
</mat-dialog-actions>
